// extracted by mini-css-extract-plugin
export default {"container":"ModalHeader--container--741ff2","title":"ModalHeader--title--c4737c","leftAction":"ModalHeader--leftAction--bfeac7"};